import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';
import _ from 'lodash';

export const utilityStart = (accessToken, data) => baseAction.actionStart(actionTypes.UTILITY_START, accessToken, data);
export const utilitySuccess = (data) => baseAction.actionSuccess(actionTypes.UTILITY_SUCCESS, data);
export const utilityFail = (error) => baseAction.actionFail(actionTypes.UTILITY_FAIL, error);

export const statesList = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/State?countryId=US', storageKey: 'statesListUS' });
export const addressTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/AddressType', storageKey: 'addressTypes' });
export const officeTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/BranchOfficeType', storageKey: 'officeTypes' });
export const phoneNumberTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/PhoneType', storageKey: 'phoneNumberTypes' });
export const emailTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/EmailType', storageKey: 'emailTypes' });
export const commissionPlanTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/CommissionPlanType', storageKey: 'commissionPlanTypes' });
export const statusTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/Status', storageKey: 'statusTypes' });
export const timeZones = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/TimeZone', storageKey: 'timeZones' });
export const mlsProviders = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/MlsProvider', storageKey: 'mlsProviders', sorted: true });
export const realEstateBoards = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/RealEstateBoard', storageKey: 'realEstateBoards' });
export const territoryTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/TerritoryType', storageKey: 'territoryTypes' });
export const mlsProviderStatuses = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/MlsProviderStatus', storageKey: 'mlsProviderStatuses' });
export const lookupTypes = (category) => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/LookupType/GetByCategoryName', storageKey: 'lookupType', sorted: true, category: category });
export const reportApplications = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/ReportApp', storageKey: 'reportApplications' });
export const reportCategories = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/ReportCategory', storageKey: 'reportCategories' });
export const propertyTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/PropertyType', storageKey: 'propertyTypes' });
export const staffTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/PropertyType', storageKey: 'propertyTypes' });
export const popupLocationTypes = () => (dispatch, getState) => cacheValues(dispatch, getState, { url: '/AnnouncementLocation/', storageKey: 'popupLocationTypes' });

export const cacheValues = (dispatch, getState, options) => {
    let storageKey = options.storageKey;
    if (options.category) { storageKey = `${storageKey}${options.category}`; }

    const storage = localStorage.getItem(storageKey);

    if (!storage) {
        let url = options.url;
        if (options.category) { url = `${url}/${options.category}`; }
        
        baseAction.actionExecute(dispatch, getState, {
            url: url,
            startFn: (accessToken) => dispatch(utilityStart(accessToken, { lastScope: storageKey })),
            successFn: (response) => {
                let data = response.data;

                if (options.sorted) {
                    data = _.orderBy(data, [item => item.name.toLowerCase()], ['asc']);
                }

                localStorage.setItem(storageKey, JSON.stringify(data));

                return dispatch(utilitySuccess({ [storageKey]: data }));
            },
            failFn: (error) => dispatch(utilityFail(error))
        });
    } else {
        dispatch(utilitySuccess({ [storageKey]: JSON.parse(storage) }));
    }
};
